// Utility function to replace or add a URL parameter
function replaceUrlParam(url, param, value) {
    var regex = new RegExp('(' + param + '=).*?(&|$)');
    if (url.search(regex) >= 0) {
        return url.replace(regex, '$1' + value + '$2');
    } else {
        return url + (url.indexOf('?') > 0 ? '&' : '?') + param + '=' + value;
    }
}

// Shopify money formatting function
Shopify.formatMoney = Shopify.formatMoney || function (cents, format) {
    var moneyFormat = format || this.money_format;
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;

    // Helper functions
    function defaultValue(value, defaultVal) {
        return value === undefined ? defaultVal : value;
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
        precision = defaultValue(precision, 2);
        thousands = defaultValue(thousands, ',');
        decimal = defaultValue(decimal, '.');

        if (isNaN(number) || number == null) return 0;

        var parts = (number / 100).toFixed(precision).split('.');
        var integerPart = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
        var decimalPart = parts[1] ? decimal + parts[1] : '';

        return integerPart + decimalPart;
    }

    var value = '';
    switch (moneyFormat.match(placeholderRegex)[1]) {
        case 'amount':
            value = formatWithDelimiters(cents, 2);
            break;
        case 'amount_no_decimals':
            value = formatWithDelimiters(cents, 0);
            break;
        case 'amount_with_comma_separator':
            value = formatWithDelimiters(cents, 2, '.', ',');
            break;
        case 'amount_no_decimals_with_comma_separator':
            value = formatWithDelimiters(cents, 0, '.', ',');
            break;
    }

    return moneyFormat.replace(placeholderRegex, value);
};

// Shopify utility functions
if (typeof Shopify === 'undefined') {
    window.Shopify = {};
}

Shopify.uniq = Shopify.uniq || function(array) {
    var result = [];
    for (var i = 0; i < array.length; i++) {
        if (result.indexOf(array[i]) === -1) {
            result.push(array[i]);
        }
    }
    return result;
};

// Shopify namespace and caching selectors
var sp = sp || {};

sp.cacheSelectors = function () {
    sp.cache = {
        $html: $('html'),
        $body: $(document.body),
        $navigation: $('#AccessibleNav'),
        $mobileSubNavToggle: $('.mobile-nav__toggle'),
        $changeView: $('.change-view'),
        $productImage: $('#ProductPhotoImg'),
        $thumbImages: $('#ProductThumbs').find('a.product-single__thumbnail'),
        $recoverPasswordLink: $('#RecoverPassword'),
        $hideRecoverPasswordLink: $('#HideRecoverPasswordLink'),
        $recoverPasswordForm: $('#RecoverPasswordForm'),
        $customerLoginForm: $('#CustomerLoginForm'),
        $passwordResetSuccess: $('#ResetSuccess'),
    };
};

sp.init = function () {
    sp.cacheSelectors();
    sp.accessibleNav();
    sp.mobileNavToggle();
    sp.productImageSwitch();
    sp.responsiveVideos();
    sp.collectionViews();
    sp.loginForms();
};

// Accessible navigation setup
sp.accessibleNav = function () {
    var $navigation = sp.cache.$navigation;
    var $links = $navigation.find('a');
    var $dropdownLinks = $navigation.find('.site-nav--has-dropdown');
    var $dropdownItems = $navigation.find('.site-nav__dropdown').find('a');
    var navHoverClass = 'nav-hover';
    var navFocusClass = 'nav-focus';

    function removeHover($element) {
        $element.removeClass(navHoverClass);
        sp.cache.$body.off('touchstart');
    }

    function addFocus($element) {
        $element.addClass(navFocusClass);
    }

    function removeFocus($element) {
        $element.removeClass(navFocusClass);
    }

    $dropdownLinks.on('mouseenter touchstart', function (e) {
        var $currentTarget = $(this);
        if (!$currentTarget.hasClass(navHoverClass)) e.preventDefault();
        addHover($currentTarget);
    });

    $dropdownLinks.on('mouseleave', function () {
        removeHover($(this));
    });

    $dropdownItems.on('touchstart', function (e) {
        e.stopImmediatePropagation();
    });

    $links.focus(function () {
        var $this = $(this);
        if ($this.next('ul').hasClass('sub-nav')) {
            addFocus($this.closest('.site-nav--has-dropdown').find('a'));
        } else {
            removeFocus($links);
            addFocus($this);
        }
    });

    $links.blur(function () {
        removeFocus($links);
    });

    function addHover($element) {
        $element.addClass(navHoverClass);
        setTimeout(function () {
            sp.cache.$body.on('touchstart', function () {
                removeHover($element);
            });
        }, 250);
    }
};

// Mobile navigation toggle
sp.mobileNavToggle = function () {
    sp.cache.$mobileSubNavToggle.on('click', function () {
        $(this).parent().toggleClass('mobile-nav--expanded');
    });
};

// Get URL hash
sp.getHash = function () {
    return window.location.hash;
};

sp.getActiveVariantId = function () {
    var params = new URLSearchParams(window.location.search);
    var fromUrl = params.get('variant');
    if (fromUrl) {
        return String(fromUrl);
    }

    var productSelect = document.getElementById('productSelect');
    if (productSelect && productSelect.value) {
        return String(productSelect.value);
    }

    var formVariantInput = document.querySelector('.product-details-page form [name="id"]');
    if (formVariantInput && formVariantInput.value) {
        return String(formVariantInput.value);
    }

    var leadTimeWrap = document.querySelector('.product-lead-time-wrap[data-initial-variant-id]');
    if (leadTimeWrap && leadTimeWrap.dataset.initialVariantId) {
        return String(leadTimeWrap.dataset.initialVariantId);
    }

    if (window.ProductState && window.ProductState.defaultVariantId) {
        return String(window.ProductState.defaultVariantId);
    }

    return null;
};

sp.getLeadTimeVariantMap = function () {
    if (sp._leadTimeVariantMap !== undefined) {
        return sp._leadTimeVariantMap;
    }

    sp._leadTimeVariantMap = null;
    var dataEl = document.getElementById('product-lead-time-data');

    if (dataEl && dataEl.textContent) {
        try {
            sp._leadTimeVariantMap = JSON.parse(dataEl.textContent);
        } catch (error) {
            sp._leadTimeVariantMap = null;
        }
    }

    return sp._leadTimeVariantMap;
};

sp.getLeadTimeVariant = function () {
    var variantId = sp.getActiveVariantId();
    if (!variantId || !window.ProductState || !window.ProductState.variants) {
        return null;
    }

    return (
        window.ProductState.variants.find(function (v) {
            return String(v.id) === String(variantId);
        }) || null
    );
};

sp.shouldShowLeadTime = function () {
    var variantId = sp.getActiveVariantId();
    if (!variantId) {
        return false;
    }

    var leadTimeMap = sp.getLeadTimeVariantMap();
    if (leadTimeMap && Object.prototype.hasOwnProperty.call(leadTimeMap, variantId)) {
        return leadTimeMap[variantId] === true;
    }

    var leadTimeVariant = sp.getLeadTimeVariant();
    if (!leadTimeVariant) {
        return false;
    }

    if (leadTimeVariant.inventory_policy !== 'continue') {
        return false;
    }

    var quantity = Number(leadTimeVariant.inventory_quantity);
    if (isNaN(quantity)) {
        return !!leadTimeVariant.available;
    }

    return quantity <= 0;
};

sp.updateLeadTimeVisibility = function () {
    var leadTimeEl = document.getElementById('ProductLeadTime');
    if (!leadTimeEl) {
        return;
    }

    var isDesignMode =
        (window.Shopify && window.Shopify.designMode) ||
        !!leadTimeEl.closest('[data-design-mode="true"]');
    var showLeadTime = isDesignMode || sp.shouldShowLeadTime();

    if (showLeadTime) {
        leadTimeEl.removeAttribute('hidden');
        leadTimeEl.style.removeProperty('display');
    } else {
        leadTimeEl.setAttribute('hidden', 'hidden');
        leadTimeEl.style.display = 'none';
    }
};

// Product page setup
sp.productPage = function (settings) {
    var moneyFormat = settings.money_format;
    var variant = settings.variant;
    var $productImage = $('#ProductPhotoImg');
    var $price = $('[id="ProductPrice"]');
    var $comparePrice = $('[id="ComparePrice"]');
    var $discount = $('[id="ProductDiscount"]');
    var $quantitySelector = $('.quantity-selector, label + .js-qty');
    var $sku = $('[id="VariantSku"]');
    var $barcode = $('#BarCode');
    var $weight = $('#Weight');
    var $inStock = $('.in-stock');
    var $outStock = $('.out-stock');
    var $notifyButton = $('.notify-btn');
    var $addToCartButton = $('.btn_theme');
    var $affiliateButton = $('.affiliate-product');
    var $stockStatus = $('.stock-more');

    if (variant) {
        // Update product image if available
        if (variant.featured_media) {
            var media = variant.featured_media;
            Shopify.Image.switchImage(media, $productImage[0], sp.switchImage);
        }

        // Update product availability and information

        $sku.text(variant.sku);

        if (variant.available) {
            $inStock.show();
            $outStock.hide();
            $weight.text(variant.weight);
            $barcode.text(variant.barcode);
            $quantitySelector.show();
            $('.ajax-spin-cart').show();

            // Enable add-to-cart buttons
            $('.add-to-cart').removeClass('disabled').prop('disabled', false);
            $('button.add-to-cart.mobile-sticky-cart').removeClass('disabled').prop('disabled', false);
            $('button.add-to-cart.mobile-sticky-cart').css('display', 'flex');
            $('.notify-btn.mobile-sticky-cart').css('display', 'none');
        } else {
            $quantitySelector.hide();
            $barcode.empty();
            $weight.empty();
            $inStock.hide();
            $outStock.show();

            // Disable add-to-cart buttons
            $('.add-to-cart').addClass('disabled').prop('disabled', true);
            $('button.add-to-cart.mobile-sticky-cart').addClass('disabled').prop('disabled', true);
            $('button.add-to-cart.mobile-sticky-cart').css('display', 'none');
            $('.notify-btn.mobile-sticky-cart').css('display', 'flex');
        }

        sp.updateLeadTimeVisibility();

        $price.html(Shopify.formatMoney(variant.price, moneyFormat));
        if (variant.compare_at_price > variant.price) {
            $discount.html(((100 * (variant.compare_at_price - variant.price)) / variant.compare_at_price).toFixed()).show();
            $comparePrice.html(Shopify.formatMoney(variant.compare_at_price, moneyFormat)).show();
        } else {
            $discount.hide();
            $comparePrice.hide();
        }

        if (variant.id) {
            document.querySelectorAll('.swatch-element').forEach(function(element) {
                element.addEventListener('click', function() {
                    if (this.classList.contains('disabled')) return;
                    var value = this.getAttribute('data-value');
                    // if value contains * get first part of it
                    value = value.split('*')[0].trim();
                    this.closest('.variant-wrap').parentNode.querySelector('#data-value').textContent = value;
                });
            });
        }

    } else {
        $('.ajax-spin-cart').show();
        $notifyButton.hide();
        $addToCartButton.addClass('disabled').prop('disabled', true);
        $affiliateButton.addClass('disabled').prop('disabled', true);
        $quantitySelector.hide();
        $sku.empty();
        $barcode.empty();
        $weight.empty();
        $('.stock-zero').show();
        $stockStatus.hide();
        $('.available-stock').text('0');
        $inStock.hide();
        $outStock.show();

        // Disable add-to-cart buttons when no variant selected
        $('.add-to-cart').addClass('disabled').prop('disabled', true);
        $('button.add-to-cart.mobile-sticky-cart').addClass('disabled').prop('disabled', true);
        $('button.add-to-cart.mobile-sticky-cart').css('display', 'flex');
        $('.notify-btn.mobile-sticky-cart').css('display', 'none');

        sp.updateLeadTimeVisibility();
    }
};

// Shopify options mapping and updating
Shopify.optionsMap = {};
Shopify.updateOptionsInSelector = function (selectorIndex) {
    var key, $selector;

    switch (selectorIndex) {
        case 0:
            key = 'root';
            $selector = $('.single-option-selector:eq(0)');
            break;
        case 1:
            key = $('.single-option-selector:eq(0)').val();
            $selector = $('.single-option-selector:eq(1)');
            break;
        case 2:
            key = $('.single-option-selector:eq(0)').val() + ' / ' + $('.single-option-selector:eq(1)').val();
            $selector = $('.single-option-selector:eq(2)');
            break;
    }

    var currentValue = $selector.val();
    $selector.empty();

    var options = Shopify.optionsMap[key];
    options.forEach(function (option) {
        var $option = $('<option></option>').val(option).html(option);
        $selector.append($option);
    });

    $('.swatch[data-option-index="' + selectorIndex + '"] .swatch-element').each(function () {
        var $this = $(this);
        if (options.includes($this.attr('data-value'))) {
            $this.removeClass('soldout').show().find(':radio').removeAttr('disabled').removeAttr('checked');
        } else {
            $this.addClass('soldout').hide().find(':radio').removeAttr('checked').attr('disabled', 'disabled');
        }
    });

    if (options.includes(currentValue)) {
        $selector.val(currentValue);
    }
    $selector.trigger('change');
};

// Initialize Shopify option selectors
Shopify.linkOptionSelectors = function (product) {
    product.variants.forEach(function (variant) {
        if (variant.available) {
            Shopify.optionsMap.root = Shopify.optionsMap.root || [];
            Shopify.optionsMap.root.push(variant.option1);
            Shopify.optionsMap.root = Shopify.uniq(Shopify.optionsMap.root);

            if (product.options.length > 1) {
                var key = variant.option1;
                Shopify.optionsMap[key] = Shopify.optionsMap[key] || [];
                Shopify.optionsMap[key].push(variant.option2);
                Shopify.optionsMap[key] = Shopify.uniq(Shopify.optionsMap[key]);
            }

            if (product.options.length === 3) {
                var compositeKey = variant.option1 + ' / ' + variant.option2;
                Shopify.optionsMap[compositeKey] = Shopify.optionsMap[compositeKey] || [];
                Shopify.optionsMap[compositeKey].push(variant.option3);
                Shopify.optionsMap[compositeKey] = Shopify.uniq(Shopify.optionsMap[compositeKey]);
            }
        }
    });

    Shopify.updateOptionsInSelector(0);
    if (product.options.length > 1) Shopify.updateOptionsInSelector(1);
    if (product.options.length === 3) Shopify.updateOptionsInSelector(2);

    $('.single-option-selector:eq(0)').change(function () {
        Shopify.updateOptionsInSelector(1);
        if (product.options.length === 3) Shopify.updateOptionsInSelector(2);
    });

    $('.single-option-selector:eq(1)').change(function () {
        if (product.options.length === 3) Shopify.updateOptionsInSelector(2);
    });
};

// Product image switch functionality
sp.productImageSwitch = function () {
    sp.cache.$thumbImages.length &&
        sp.cache.$thumbImages.on('click', function () {
            var imageId = $(this).find('img').attr('data-image-id');
            $('.slider-big .slick-slide[data-image-id="' + imageId + '"]').trigger('click');
        });
};

// Image switch helper function
sp.switchImage = function (image, element, switchImage) {
    $(element).attr('src', image);
};

// Form cart submission helper function
sp.formCart = function () {
    $('form.cart-').submit();
};

// Responsive videos setup
sp.responsiveVideos = function () {
    var $videos = $('iframe[src*="youtube.com/embed"], iframe[src*="player.vimeo"]');
    var $iframes = $videos.add('iframe#admin_bar_iframe');

    $videos.each(function () {
        $(this).wrap('<div class="video-wrapper"></div>');
    });

    $iframes.each(function () {
        this.src = this.src;
    });
};

// Collection views setup
sp.collectionViews = function () {
    sp.cache.$changeView.length &&
        sp.cache.$changeView.on('click', function () {
            var view = $(this).data('view');
            var url = document.URL;
            var hasQuery = url.indexOf('?') > -1;
            window.location = hasQuery ? replaceUrlParam(url, 'view', view) : url + '?view=' + view;
        });
};

// Login forms setup
sp.loginForms = function () {
    function showRecoverPasswordForm() {
        sp.cache.$recoverPasswordForm.show();
        sp.cache.$customerLoginForm.hide();
    }

    sp.cache.$recoverPasswordLink.on('click', function (e) {
        e.preventDefault();
        showRecoverPasswordForm();
    });

    sp.cache.$hideRecoverPasswordLink.on('click', function (e) {
        e.preventDefault();
        sp.cache.$recoverPasswordForm.hide();
        sp.cache.$customerLoginForm.show();
    });

    if (sp.getHash() === '#recover') {
        showRecoverPasswordForm();
    }
};

// Reset password success handler
sp.resetPasswordSuccess = function () {
    sp.cache.$passwordResetSuccess.show();
};

// Drawer functionality
sp.Drawers = (function () {
    var Drawer = function (id, position, options) {
        var defaults = {
            close: '.js-drawer-close',
            open: '.js-drawer-open-' + position,
            openClass: 'js-drawer-open',
            dirOpenClass: 'js-drawer-open-' + position,
        };

        this.$nodes = {
            parent: $('body, html'),
            page: $('#PageContainer'),
            moved: $('.is-moved-by-drawer'),
        };

        this.config = $.extend(defaults, options);
        this.position = position;
        this.$drawer = $('#' + id);

        if (!this.$drawer.length) return false;
        this.drawerIsOpen = false;
        this.init();
    };

    Drawer.prototype.init = function () {
        $(this.config.open).on('click', $.proxy(this.open, this));
        this.$drawer.find(this.config.close).on('click', $.proxy(this.close, this));
    };

    Drawer.prototype.open = function (event) {
        var forceOpen = !event;

        if (event) {
            event.preventDefault();
            event.stopPropagation();
            this.$activeSource = $(event.currentTarget);
        }

        if (this.drawerIsOpen && !forceOpen) return this.close();

        sp.cache.$body.trigger('beforeDrawerOpen.sp', this);

        this.$nodes.moved.addClass('is-transitioning');
        this.$drawer.prepareTransition();
        this.$nodes.parent.addClass(this.config.openClass + ' ' + this.config.dirOpenClass);
        this.drawerIsOpen = true;
        this.trapFocus(this.$drawer, 'drawer_focus');

        if (this.config.onDrawerOpen && typeof this.config.onDrawerOpen === 'function') {
            if (forceOpen) this.config.onDrawerOpen();
        }

        if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
            this.$activeSource.attr('aria-expanded', 'true');
        }

        this.$nodes.page.on('touchmove.drawer', function () {
            return false;
        });

        this.$nodes.page.on('click.drawer', $.proxy(function () {
            this.close();
            return false;
        }, this));

        sp.cache.$body.trigger('afterDrawerOpen.sp', this);
    };

    Drawer.prototype.close = function () {
        if (!this.drawerIsOpen) return;

        sp.cache.$body.trigger('beforeDrawerClose.sp', this);

        $(document.activeElement).trigger('blur');
        this.$nodes.moved.prepareTransition({ disableExisting: true });
        this.$drawer.prepareTransition({ disableExisting: true });
        this.$nodes.parent.removeClass(this.config.dirOpenClass + ' ' + this.config.openClass);
        this.drawerIsOpen = false;
        this.removeTrapFocus(this.$drawer, 'drawer_focus');
        this.$nodes.page.off('.drawer');

        sp.cache.$body.trigger('afterDrawerClose.sp', this);
    };

    Drawer.prototype.trapFocus = function ($element, eventNamespace) {
        var eventName = eventNamespace ? 'focusin.' + eventNamespace : 'focusin';
        $element.attr('tabindex', '-1').focus();

        $(document).on(eventName, function (event) {
            if ($element[0] !== event.target && !$element.has(event.target).length) {
                $element.focus();
            }
        });
    };

    Drawer.prototype.removeTrapFocus = function ($element, eventNamespace) {
        var eventName = eventNamespace ? 'focusin.' + eventNamespace : 'focusin';
        $element.removeAttr('tabindex');
        $(document).off(eventName);
    };

    return Drawer;
})();

$(sp.init);
